import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDog, faCat } from '@fortawesome/free-solid-svg-icons';
import { catPackages, contactData, dogPackages, packageLinks, pricing } from './data';

const packageOrder = ['Standard', 'Premium', 'Platinum', 'VIP'];

const animalContent = {
  dog: {
    icon: faDog,
    eyebrow: 'Zakup pakietu dla psa',
    title: 'Pakiet weterynaryjny Pethelp dla psa.',
    lead:
      'Na jednym ekranie masz zakres usług, ceny i bezpośrednie przejście do zakupu wybranego wariantu.',
    priceTitle: 'Pakiety dla psa',
    pricingTitle: 'Wybierz wariant dla psa',
    note:
      'Różnice między pakietami dla psa obejmują zarówno ceny, jak i zakres wizyt, badań, szczepień oraz konsultacji specjalistycznych.',
    sections: dogPackages,
    highlights: [
      'Badania obrazowe (RTG, USG, Echo Serca) pojawiają się tylko w wybranych wariantach i rosną wraz z pakietem.',
      'Budżet na preparaty przeciwpasożytnicze zwiększa się wraz z poziomem pakietu.',
      'Konsultacje online ze specjalistami są dostępne od wyższych wariantów.'
    ]
  },
  cat: {
    icon: faCat,
    eyebrow: 'Zakup pakietu dla kota',
    title: 'Pakiet weterynaryjny Pethelp dla kota.',
    lead:
      'Tutaj od razu porównasz zakres opieki, ceny oraz przejdziesz do zakupu pakietu dopasowanego do kota.',
    priceTitle: 'Pakiety dla kota',
    pricingTitle: 'Wybierz wariant dla kota',
    note:
      'Pakiety dla kota mają własny zakres badań i szczepień, dlatego zakup został rozdzielony na osobną ścieżkę.',
    sections: catPackages,
    highlights: [
      'Test FIV/FeLV jest dostępny wyłącznie w wariantach dla kota.',
      'W wyższych pakietach dostępne jest szczepienie przeciw białaczce FeLV.',
      'Pakiet dla kota startuje od niższej ceny miesięcznej niż wariant dla psa.'
    ]
  }
};

const PackagesTable = ({ sections, variant }) => {
  const pricingByPackage = pricing[variant].reduce((result, [packageName, amount]) => {
    result[packageName] = amount;
    return result;
  }, {});

  return (
    <table className={`table table-bordered pethelp-package-table pethelp-package-table-${variant}`}>
      <thead>
        <tr className="text-center">
          <th>Zakres pakietu</th>
          {packageOrder.map((packageName) => (
            <th key={packageName}>{packageName}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sections.map((section) => (
          <React.Fragment key={section.category}>
            <tr className="table-active">
              <td colSpan="5">
                <b>{section.category}</b>
              </td>
            </tr>
            {section.items.map((item) => (
              <tr key={item[0]}>
                <td>{item[0]}</td>
                <td className="text-center">{item[1]}</td>
                <td className="text-center">{item[2]}</td>
                <td className="text-center">{item[3]}</td>
                <td className="text-center">{item[4]}</td>
              </tr>
            ))}
          </React.Fragment>
        ))}
        <tr className="pethelp-package-actions-row">
          <td className="pethelp-package-actions-label">
            <strong>Oblicz składkę</strong>
          </td>
          {packageOrder.map((packageName) => (
            <td key={packageName} className="text-center">
              <a
                className="pethelp-package-button"
                aria-label={`Oblicz składkę dla pakietu ${packageName}`}
                href={packageLinks[variant][packageName]}
                target="_blank"
                rel="noopener noreferrer">
                <span className="pethelp-package-button-title">{packageName}</span>
                <span className="pethelp-package-button-price">
                  {pricingByPackage[packageName]} / mies.
                </span>
              </a>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

const OfertaPakietu = ({ type }) => {
  const content = animalContent[type];

  return (
    <div className="pethelp-page">
      <section className="pethelp-hero">
        <div className="pethelp-eyebrow">{content.eyebrow}</div>
        <h1 className="pethelp-title">
          <FontAwesomeIcon icon={content.icon} style={{ marginRight: '0.65rem' }} />
          {content.title}
        </h1>
        <p className="pethelp-lead">{content.lead}</p>
      </section>

      <div className="pethelp-card mt-4">
        <div className="pethelp-eyebrow">Na co zwrócić uwagę</div>
        <ul className="pethelp-points">
          {content.highlights.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <div className={`pethelp-table-card ${type === 'dog' ? 'pethelp-table-card-dog' : 'pethelp-table-card-cat'}`}>
        <div
          className="pethelp-table-scroll"
          role="region"
          aria-label={content.priceTitle}>
          <PackagesTable sections={content.sections} variant={type} />
        </div>
      </div>

      {/* <section className="mt-4">
        <PriceTable
          type={type}
          title={content.pricingTitle}
          activePackage={activePackage}
          onSelect={(packageName) =>
            setActivePackage((current) => (current === packageName ? null : packageName))
          }
        />
      </section> */}

      <div className="pethelp-note">
        {content.note}{' '}
        <a
          href={contactData.insurance}
          target="_blank"
          rel="noopener noreferrer">
          Szczegóły dodatkowej ochrony i finalne warunki zakupu są dostępne na
          stronie Pethelp.
        </a>
      </div>
    </div>
  );
};

export const PakietDlaPsa = () => <OfertaPakietu type="dog" />;

export const PakietDlaKota = () => <OfertaPakietu type="cat" />;

export default OfertaPakietu;
